module.exports = __webpack_public_path__ + "img/banner2.5989f882.jpg";